import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excerpt',
})
export class ExcerptPipe implements PipeTransform {
  transform(value: string, ...args: number[]): unknown {
    const sliceSize = args[0] ? args[0] : 15;
    return value.length >= sliceSize ? `${value.slice(0, sliceSize)}...` : value;
  }
}
